// extracted by mini-css-extract-plugin
export default {"tableItemButtonSelect":"ButtonSlideProducts_tableItemButtonSelect__DPwk5","changeButton":"ButtonSlideProducts_changeButton__XfSWC","disabled":"ButtonSlideProducts_disabled__pvmI9"};